var map = {
	"./": 2236,
	"./BreakoutQuote": 4823,
	"./BreakoutQuote/": 4823,
	"./BreakoutQuote/fable": 6818,
	"./BreakoutQuote/fable.js": 6818,
	"./BreakoutQuote/index": 4823,
	"./BreakoutQuote/index.jsx": 4823,
	"./BreakoutQuote/queries.gql": 2215,
	"./BreakoutQuote/queries.gql.js": 2215,
	"./CardGrid": 7799,
	"./CardGrid/": 7799,
	"./CardGrid/index": 7799,
	"./CardGrid/index.jsx": 7799,
	"./CardGrid/queries.gql": 8467,
	"./CardGrid/queries.gql.js": 8467,
	"./CardGrid/styles.module.scss": 809,
	"./HeroWithCenteredText": 6060,
	"./HeroWithCenteredText/": 6060,
	"./HeroWithCenteredText/index": 6060,
	"./HeroWithCenteredText/index.jsx": 6060,
	"./HeroWithCenteredText/queries.gql": 4029,
	"./HeroWithCenteredText/queries.gql.js": 4029,
	"./HeroWithCenteredText/styles.module.scss": 2335,
	"./InlineQuote": 545,
	"./InlineQuote/": 545,
	"./InlineQuote/index": 545,
	"./InlineQuote/index.jsx": 545,
	"./InlineQuote/queries.gql": 4307,
	"./InlineQuote/queries.gql.js": 4307,
	"./InlineQuote/styles.module.scss": 1971,
	"./InlineTable": 1750,
	"./InlineTable/": 1750,
	"./InlineTable/index": 1750,
	"./InlineTable/index.jsx": 1750,
	"./InlineTable/queries.gql": 8090,
	"./InlineTable/queries.gql.js": 8090,
	"./InlineTable/styles.module.scss": 8291,
	"./TwoColWithMedia": 2084,
	"./TwoColWithMedia/": 2084,
	"./TwoColWithMedia/index": 2084,
	"./TwoColWithMedia/index.jsx": 2084,
	"./TwoColWithMedia/queries.gql": 1488,
	"./TwoColWithMedia/queries.gql.js": 1488,
	"./TwoColWithMedia/styles.module.scss": 1499,
	"./Wysiwyg": 3536,
	"./Wysiwyg/": 3536,
	"./Wysiwyg/index": 3536,
	"./Wysiwyg/index.jsx": 3536,
	"./Wysiwyg/queries.gql": 2202,
	"./Wysiwyg/queries.gql.js": 2202,
	"./Wysiwyg/styles.scss": 1099,
	"./fables": 5580,
	"./fables.js": 5580,
	"./index": 2236,
	"./index.js": 2236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 2184;
module.exports = webpackContext;